/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_SCREENSHOT_DETAILS_REQUEST,
  FETCH_SCREENSHOT_DETAILS_SUCCESS,
  FETCH_SCREENSHOT_DETAILS_FAILURE,
  FETCH_DELETE_SCREENSHOT_REQUEST,
  FETCH_DELETE_SCREENSHOT_SUCCESS,
  FETCH_DELETE_SCREENSHOT_FAILURE,
} from "./ScreenshotsUploadTypes";

const initialState = {
  loading: false,
  screenshots: {},
  error: "",
};

const screenshotDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCREENSHOT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_SCREENSHOT_DETAILS_SUCCESS:
      return {
        loading: false,
        screenshots: action.payload,
        error: "",
      };
    case FETCH_SCREENSHOT_DETAILS_FAILURE:
    case FETCH_DELETE_SCREENSHOT_FAILURE:
      return {
        loading: false,
        screenshots: {},
        error: action.payload,
      };

    case FETCH_DELETE_SCREENSHOT_REQUEST:
      return {
        loading: true,
        screenshots: {},
        error: false,
      };

    case FETCH_DELETE_SCREENSHOT_SUCCESS:
      return {
        loading: false,
        screenshots: {},
        error: false,
      };
    default:
      return state;
  }
};

export default screenshotDetailsReducer;
